import axios from "axios";
import MentorProfile from "../components/MentorProfile";

export default {
  components: {
    MentorProfile
  },
  data() {
    return {
      hubs: [],
      hub: null,
      mentors: [],
      showMentorProfile: false,
      currentMentor: null
    };
  },
  mounted() {
    if (this.$route.params.hubId) {
      this.getHubWithMentors();
    } else {
      this.getHubs();
    }
  },
  methods: {
    getHubs() {
      axios
        .get(process.env.API_URL + "/hub", this.config)
        .then(response => {
          if (response.status == 200) {
            this.hubs = response.data.sort((a, b) =>
              a.name > b.name ? 1 : -1
            );
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getHubWithMentors() {
      axios
        .get(
          `${process.env.API_URL}/hub/${this.$route.params.hubId}/mentors`,
          this.config
        )
        .then(response => {
          if (response.status == 200) {
            this.hub = response.data.hub;
            if (response.data.manager) {
              let test = response.data.mentors;
              test.unshift(response.data.manager);
              this.mentors = test;
            } else {
              this.mentors = response.data.mentors;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    showMentorModal(mentor) {
      this.currentMentor = mentor;
      this.showMentorProfile = true;
    }
  }
};
